import { useTranslation } from 'react-i18next';
import menuService from '../menuService';

export default function CSVDownloader() {
  const { t } = useTranslation();
  const handleExportCSV = async () => {
    try {
      const response = await menuService.getMenuImportCsvTemplate();
      const url = URL.createObjectURL(response);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.download = t('MenuList.ModalImportCsv.template_name');
      // Trigger the click event to download the CSV file
      link.click();
      // Clean up the URL object
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error fetching CSV:', error);
    }
  };
  return (
    <button className="btn btn-link" onClick={handleExportCSV}>
      {t('MenuList.ModalImportCsv.template_link')}
    </button>
  );
}
